import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from './pages/LandingPage/AppLayout';
import routes from './routes';

function App() {

  return (
    <BrowserRouter future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
      <Suspense fallback={"Loading..."}>
        <AppLayout routers={routes.routes.map((item) => item)} />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;

